import { CertificatePermission } from './api';
import { ReactNode } from 'react';

/**
 * 图标点击类型枚举
 */
export enum IconClickType {
    SELECT = 'select', // 选择模式（当前功能）
    JUMP = 'jump', // 跳转模式
}

/**
 * 分享图标项接口
 */
export interface IShareIconItem {
    key: string; // 唯一标识
    icon: string; // 样式名称
    label: string;
    src: any;
}

/**
 * 分享信息接口
 */
export interface IShareInfo {
    permission: CertificatePermission; // 权限开关状态
    selectedIcons: string[]; // 选中的分享图标key数组
}

/**
 * Share 基础属性接口
 */
export interface ICaetShareBasicProps {
    link: string;
    id: string;
    permission?: CertificatePermission;
    iconList?: IShareIconItem[];
    showShareIcon?: boolean;
    /** 是否支持多选，默认为单选 */
    multiple?: boolean;
    /** 图标点击类型，默认为选择模式 */
    iconClickType?: IconClickType;
}

/**
 * Share 组件属性接口
 */
export interface ICaetShareProps extends ICaetShareBasicProps {
    onPermission?: (value: CertificatePermission) => void;
}

/**
 * Share 组件引用接口
 */
export interface ICaetShareRef {
    getShareInfo: () => IShareInfo;
}

/**
 * ShareIcon 组件属性接口
 */
export interface IShareIconProps {
    iconItem: IShareIconItem;
    isSelected: boolean;
    onClick: (iconKey: string) => void;
}

/**
 * useCaetShare Hook 参数接口
 */
export interface IUseCaetShareParams {
    link: string;
    showShareIcon: boolean;
    iconList?: IShareIconItem[];
    permission?: CertificatePermission;
    onPermission?: (value: CertificatePermission) => void;
    ref: React.Ref<{ getShareInfo: () => IShareInfo }>;
    multiple?: boolean;
    iconClickType?: IconClickType;
}

/**
 * useCaetShare Hook 返回值接口
 */
export interface IUseCaetShareReturn {
    /** 分享信息状态 */
    info: IShareInfo;
    /** 显示的图标列表 */
    displayIconList: IShareIconItem[];
    /** 是否应该展示图标 */
    shouldShowIcons: boolean;
    /** 权限开关切换处理函数 */
    handlePermissionChange: (checked: boolean) => void;
    /** 分享图标点击处理函数 */
    handleIconClick: (iconKey: string) => void;
    /** 复制链接处理函数 */
    handleCopyLink: () => void;
    /** 当前显示的链接（跳转模式下始终显示原始链接） */
    displayLink: string;
}

/**
 * Share 对话框属性接口
 */
export interface ICaetShareDialogProps extends ICaetShareBasicProps {
    okText?: string;
    title?: string | JSX.Element | ReactNode;
    onConfirm?: (shareInfo: IShareInfo, id: string) => Promise<{ isSuccess: boolean; message?: string }>;
    onSuccessCallback?: (shareInfo: IShareInfo) => void;
}
